<template>
  <div class="card" :class="{'ems': $store.state.user.job === 'EMS', 'pemerintah': $store.state.user.job === 'Pemerintah'}">
    <div class="card__container">
      <h1 class="account__title">Profile</h1>
      <p class="empty" :class="{error: errorMsg !== ''}">{{errorMsg}}</p>
      <p class="empty" :class="{success: successMsg !== ''}">{{successMsg}}</p>
      <div class="form__control">
        <label for="first_name">Role:</label>
        <p>{{role}}</p>
      </div>
      <div class="form__control">
        <label for="first_name">Nama Depan:</label>
        <input type="text" disabled v-model="firstName" name="first_name" placeholder="Silahkan masukan nama depan staff" />
      </div>
      <div class="form__control">
        <label for="last_name">Nama Belakang:</label>
        <input type="text" disabled v-model="lastName" name="last_name" placeholder="Silahkan masukan nama belakang staff" />
      </div>
      <div class="form__control">
        <label for="username">Username:</label>
        <input type="text" disabled v-model="username" name="username" placeholder="Silahkan masukan Username staff" />
      </div>
      <div class="form__control">
        <label for="password">Current Password:</label>
        <input type="password" v-model="password" name="password" placeholder="Silahkan masukan Password lama anda" />
      </div>
      <div class="form__control">
        <label for="password">New Password:</label>
        <input type="password" v-model="newPassword" name="password" placeholder="Silahkan masukan Password baru anda" />
      </div>
      <div class="form__control">
        <label for="password">Confirm New Password:</label>
        <input type="password" v-model="confirmPassword" name="password" placeholder="Silahkan masukan Password baru anda sekali lagi" />
      </div>
      <div class="form__control">
        <label for="pekerjaan">Pekerjaan:</label>
        <input type="text" v-model="job" name="pekerjaan" disabled placeholder="Silahkan masukan pekerjaan staff" />
      </div>
      <div class="form__control form__control--submit">
        <button class="discard" :class="{animate: !checkValue}" @click.prevent="discardHandler()">Discard</button>
        <button @click.prevent="submitHandler()">Save</button>
      </div>
    </div>
  </div>
</template>

<script>
  import ProfileController from '../../Controller/ProfileController.vue';
  export default {
    extends: ProfileController,
    data() {
      return {
        firstName: this.$store.state.user.firstName,
        lastName: this.$store.state.user.lastName,
        role: '',
        username: '',
        password: '',
        newPassword: '',
        confirmPassword: '',
        job: this.$store.state.user.job,
        errorMsg: '',
        successMsg: '',
      }
    },
    computed: {
      checkValue() {
        return this.password === '' && this.newPassword === '' && this.confirmPassword === ''
      },
      checkNewPass() {
        return this.newPassword === this.confirmPassword;
      }
    },
    mounted() {
      this.getUsername(this.$store.state.user.id)
        .then(data => {
          console.log(data)
          if(data.result !== undefined && data.result.length > 0) {
            this.username = data.result[0].username;
            this.role = data.result[0].role;
          }
        })
    },
    methods: {
      discardHandler() {
        this.password = '';
        this.newPassword = '';
        this.confirmPassword = '';
      },
      submitHandler() {
        if(!this.checkValue && this.checkNewPass) {
          this.updatePassword(this.$store.state.user.id, this.password, this.newPassword)
            .then(data => {
              if(data.status !== undefined && data.status === 204) {
                this.discardHandler();
                this.successMsg = 'Berhasil dalam mengupdate password';
                setTimeout(() => {
                  this.successMsg = '';
                }, 3000)
              } else {
                this.errorMsg = data.msg;
              }
            })
        } else {
          if(!this.checkNewPass) {
            this.errorMsg = 'Kolom New Password dan Confirm New Password tidak sama';
          } else {
            this.errorMsg = 'Kolom Current Password, New Password, dan Confirm New Password tidak boleh kosong'
          }
        }
      }
    },
  }
</script>

<style scoped>
  .account__title {
    font-size: 35px;
    margin-top: 40px;
  }
  .form__control {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 20px;
    font-size: 18px;
  }
  .form__control--submit {
    justify-content: space-between;
  }
  .form__control label {
    width: 200px;
    font-size: 25px;
  }

  .form__control input {
    margin: 0 0 0 20px;
    background: white;
    color: black;
    font-size: 18px;
    border: solid 1px #000;
    border-radius: 5px;
    padding: 5px 10px;
    width: 75%;
    height: 50px;
  }

  .form__control input::placeholder {
    color: rgb(134, 134, 134);
  }
  .form__control select {
    margin-left: 20px;
    font-size: 18px;
    padding: 10px;
    border-radius: 5px;
  }

  .form__control p {
    margin-left: 20px;
    font-size: 25px;
  }

  .form__control input:disabled {
    background: #ddd;
    border-color: rgba(118, 118, 118, 0.3);
  }

  .discard {
    opacity: 0;
    scale: 0;
    transition: all .2s;
  }

  .animate {
    opacity: 1;
    scale: 1;
  }

  .empty {
    display: none;
    margin-top: 20px;
    font-size: 20px;
    color: #ff5b5b;
  }
  
  .error, .success {
    display: block;
  }

  .success {
    color: white;
  }
</style>